<template>
    <div class="table-user">
        <template>
            <div class="table-user-header">
                <b-row class="pb-3">
                    <search-field :label="'Buyer:'"
                                  class="col-3"
                                  @searchValue="event => searchField(event)"/>
                    <date-filters @dateFromAction="filterTable($event)" @dateToAction="filterTable($event)" />
                </b-row>
            </div>
            <div class="scroll-x">
                <table-element
                    :items="orders"
                    :fields="fields"
                    @sort="event => sortTable(event)">
                    <template slot="orderParcels" slot-scope="data">
                        {{data.value.length}}
                    </template>
                    <order-actions slot="actions"
                                   slot-scope="data"
                                   :order-id="data.item.id"
                                   :updateList="getItems"
                                   :error="getItemsError(data.item)"
                                   @getDelivery="getOrderDelivery"/>
                </table-element>
            </div>
            <div class="table-user-footer">
                <table-pagination
                    v-if="settingsPaginationFromApi.total >= quantityProductOnPage"
                    @paginateAction="updatePagination"
                    :settings="settingsPaginationFromApi"
                    :perPageArray="quantityProductVariations"/>
            </div>
        </template>

        <order-delivery
            @hide="disabledTableBusy = false"
            @show="disabledTableBusy = true"
            @updateList="getItems"
            :id="idForDelivery"
            :preferableDelivery="preferableDelivery"
            :orderAddress="orderAddress"
            :minInsurancePrice="minInsurancePrice"
            :showLockers="showLockers" />
    </div>
</template>

<script>
    import {tableMixins, paginationMixin, routePaginationMixin} from '@/mixins/tableMixins'
    import {startFulfillment} from '@/mixins/startFulfillment'

    import TableElement from '~cp/UserPanel/Elements/TableElement'
    import SearchField from '~cp/UserPanel/Elements/SearchField'
    import DateFilters from '~cp/UserPanel/Elements/DateFilters'
    import OrderActions from '~cp/UserPanel/Pages/Orders/OrderActions'

    import ordersDraft from '@/assets/js/columns/ordersDraft'
    import {ordersList as ordersFilterOptions} from '@/assets/js/table-options/orders'

    import TablePagination from '~cp/UserPanel/Elements/TablePagination'

    export default {
        name: 'DraftOrders',
        mixins: [tableMixins, paginationMixin, routePaginationMixin, startFulfillment],
        components: {
            TableElement,
            SearchField,
            DateFilters,
            OrderActions,
            TablePagination
        },
        data() {
            return {
                endpoint: this.$endpoints.orders.list,
                options: ordersFilterOptions,
                fields: ordersDraft,
                requiredApiParams: {
                    'filter[status]': 'new',
                    'filter[service]': 'boxiti',
                    'sort[createdAt]': 'desc'
                }
            }
        },
        methods: {
            setItems() {
                let items = []
                this.items.forEach(order => {
                    order.status = []
                    order.productQuantity = []
                    order.available = []
                    order.orderedProducts.forEach(product => {
                        order.status.push(product.product.status)
                        order.productQuantity.push(product.orderedQuantity)
                        order.available.push(product.product.stock.available)
                    })
                    items.push(order)
                })
                return items
            }
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Orders/DraftOrders.vue